const DEV_SERVER_PORT = '3000';
const DEV_API_BASE = 'http://localhost:3001';

export function resolveApiBase() {
  if (typeof window === 'undefined' || !window.location) {
    return DEV_API_BASE;
  }

  // The craco dev server has no /api proxy. Every built image is served by
  // nginx, which proxies /api/ to the backend on the same origin.
  if (window.location.port === DEV_SERVER_PORT) {
    return DEV_API_BASE;
  }

  return window.location.origin;
}

const API_BASE = resolveApiBase();

let accessTokenGetter = null;
let idTokenGetter = null;

export function setAccessTokenGetter(getter) {
  accessTokenGetter = getter;
}

export function setIdTokenGetter(getter) {
  idTokenGetter = getter;
}

export async function getAccessToken() {
  if (!accessTokenGetter) {
    return null;
  }

  try {
    return await accessTokenGetter();
  } catch {
    return null;
  }
}

export async function getIdToken() {
  if (!idTokenGetter) {
    return null;
  }

  try {
    return await idTokenGetter();
  } catch {
    return null;
  }
}

export async function authHeaders() {
  const headers = {};
  const [accessToken, idToken] = await Promise.all([getAccessToken(), getIdToken()]);
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  if (idToken) {
    headers['X-ID-Token'] = idToken;
  }
  return headers;
}

export async function apiFetch(path, options = {}) {
  const headers = new Headers(options.headers || {});

  const tokens = await authHeaders();
  if (tokens.Authorization && !headers.has('Authorization')) {
    headers.set('Authorization', tokens.Authorization);
  }
  if (tokens['X-ID-Token'] && !headers.has('X-ID-Token')) {
    headers.set('X-ID-Token', tokens['X-ID-Token']);
  }

  // only set content type when body is present and caller didn't set one.
  if (options.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    mode: 'cors',
    credentials: 'include',
    headers
  });

  const contentType = res.headers.get('content-type') || '';
  const data = contentType.includes('application/json')
    ? await res.json()
    : await res.text();

  if (!res.ok) {
    throw new Error(data?.error || data || 'Request failed');
  }

  return data;
}